/*
* ３Ｄ部品 管理情報    PartsDef.xml
*/
export class AutoObjParts {
    public id: string;

    public type: string;

    public color: string;

    public name: string;

    public nameEn: string;

    public thumbnail: string;

    public shadow: string;

    public fileName: string;

    public width: string;

    public high: string;

    public depth: string;

    public offX: string;

    public offY: string;

    public offZ: string;

    public rotZ: string;

    public category: string;

    public alternat: Array<AutoObjParts>;

    constructor() {
      this.id = '';
      this.type = '';
      this.color = '';
      this.name = '';
      this.nameEn = '';
      this.thumbnail = '';
      this.shadow = '';
      this.fileName = '';
      this.width = '';
      this.high = '';
      this.depth = '';
      this.offX = '';
      this.offY = '';
      this.offZ = '';
      this.rotZ = '';
      this.category = '';
      this.alternat = [];
    }

    /*------------------------------------------------------
    * ３Ｄ部品 管理情報 アイテムコードで検索
    */
    public IsHit(item: string): boolean {
      if (this.id === item) return true;
      return false;
    }

    /*------------------------------------------------------
    * ３Ｄ部品 管理情報 ＸＭＬ読み込み
    */
    public readXML(item: Element) {
      const attr = item.attributes;
      const nodeId = attr.getNamedItem('id');
      if (nodeId != null) {
        this.id = nodeId.nodeValue;
      }

      const nodeType = attr.getNamedItem('type');
      if (nodeType != null) {
        this.type = nodeType.nodeValue;
      }

      const nodeColor = attr.getNamedItem('color');
      if (nodeColor != null) {
        this.color = nodeColor.nodeValue;
      }

      const nodeThum = attr.getNamedItem('thumbnail');
      if (nodeThum != null) {
        this.thumbnail = nodeThum.nodeValue;
      }

      // this.shadow = attr.getNamedItem( 'shadow' ).nodeValue;
      const nodeShad = attr.getNamedItem('shadow');
      if (nodeShad != null) {
        this.shadow = nodeShad.nodeValue;
      }

      const nodeName = attr.getNamedItem('name');
      if (nodeName != null) {
        this.name = nodeName.nodeValue;
      }

      const nodeNameEN = attr.getNamedItem('name_en');
      if (nodeNameEN != null) {
        this.nameEn = nodeNameEN.nodeValue;
      }

      const nodeFname = attr.getNamedItem('fname');
      if (nodeFname != null) {
        this.fileName = nodeFname.nodeValue;
      }

      const nodeWidth = attr.getNamedItem('width');
      if (nodeWidth != null) {
        this.width = nodeWidth.nodeValue;
      }

      const nodeHigh = attr.getNamedItem('high');
      if (nodeHigh != null) {
        this.high = nodeHigh.nodeValue;
      }

      const nodeDepth = attr.getNamedItem('depth');
      if (nodeDepth != null) {
        this.depth = nodeDepth.nodeValue;
      }

      const nodeOffX = attr.getNamedItem('offX');
      if (nodeOffX != null) {
        this.offX = nodeOffX.nodeValue;
      }

      const nodeOffY = attr.getNamedItem('offY');
      if (nodeOffY != null) {
        this.offY = nodeOffY.nodeValue;
      }

      const nodeOffZ = attr.getNamedItem('offZ');
      if (nodeOffZ != null) {
        this.offZ = nodeOffZ.nodeValue;
      }

      const nodeRotZ = attr.getNamedItem('rotZ');
      if (nodeRotZ != null) {
        this.rotZ = nodeRotZ.nodeValue;
      }

      const category = attr.getNamedItem('category');
      if (category != null) {
        this.category = category.nodeValue;
      }

      const alternat = item.getElementsByTagName('alternative');
      if (alternat.length > 0) {
        const alterList = alternat[0].getElementsByTagName('alt_item');
        for (let i = 0; i < alterList.length; i += 1) {
          const altp = new AutoObjParts();
          altp.readXML(alterList[i]);
          this.alternat.push(altp);
        }
      }
    }
}

/** *****************************************************
*******************************************************
* 建具部品 管理情報                      PartsDef.xml
*/
export class AutoObjFitDef {
    public id: string;

    public type: string;

    public name: string;

    public animename: string;

    public filename: string;

    public height: string;

    public roh: string;

    public row: string;

    constructor() {
      this.id = '';
      this.name = '';
      this.type = '';
      this.filename = '';
      this.animename = '';
      this.height = '';
      this.roh = '';
      this.row = '';
    }

    /*------------------------------------------------------
    * 建具部品 管理情報 ＸＭＬ読み込み
    */
    public readXML(item: any) {
      const attr = item.attributes;
      const nodeId = attr.getNamedItem('id');
      if (nodeId != null) {
        this.id = nodeId.nodeValue;
      }

      const nodeName = attr.getNamedItem('name');
      if (nodeName != null) {
        this.name = nodeName.nodeValue;
      }

      const nodeFname = attr.getNamedItem('fname');
      if (nodeFname != null) {
        this.filename = nodeFname.nodeValue;
      }

      const nodeAnime = attr.getNamedItem('animename');
      if (nodeAnime != null) {
        this.animename = nodeAnime.nodeValue;
      }

      const nodeHigh = attr.getNamedItem('height');
      if (nodeHigh != null) {
        this.height = nodeHigh.nodeValue;
      }

      const nodeRoh = attr.getNamedItem('roh');
      if (nodeRoh != null) {
        this.roh = nodeRoh.nodeValue;
      }

      const nodeRow = attr.getNamedItem('row');
      if (nodeRow != null) {
        this.row = nodeRow.nodeValue;
      }
      // this.type = item.innerHTML;
    }

    /*------------------------------------------------------
    * 建具部品 管理情報 定義名で検索
    */
    public IsHit(id: string): boolean {
      if (this.id === id) {
        return true;
      }
      return false;
    }
}

/** *****************************************************
*******************************************************
* 建具部品 管理情報                      PartsDef.xml
*/
export class AutoObjFitHigh {
    public highName: string;

    public FitDefArray: Array<AutoObjFitDef>;

    constructor() {
      this.highName = '';
      this.FitDefArray = [];
    }

    /*------------------------------------------------------
    * 建具部品 管理情報 ＸＭＬ読み込み
    */
    public readXML(item: Element) {
      const cnode = item.childNodes;
      if (cnode.length > 0) {
        for (let i = 0; i < cnode.length; i += 1) {
          if (cnode[i].nodeName === 'item') {
            const fit = new AutoObjFitDef();
            fit.readXML(cnode[i]);

            this.FitDefArray.push(fit);
          }
        }
      }
    }

    /*------------------------------------------------------
    * 建具部品 管理情報 高さ名で検索
    */
    public IsHit(name: string): boolean {
      if (this.highName === name) {
        return true;
      }
      return false;
    }

    /*------------------------------------------------------
    * 建具部品 管理情報 Array内を id で検索
    */
    public search(id: string): AutoObjFitDef {
      for (let i = 0; i < this.FitDefArray.length; i += 1) {
        if (this.FitDefArray[i].IsHit(id) === true) {
          return this.FitDefArray[i];
        }
      }
      return null;
    }
}
